module.exports = __webpack_public_path__ + "img/salon-comfort.5a2d1fbf.svg";